import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, BookOpen, BadgeCheck, User, ShoppingCart } from "lucide-react";
// ❌ remove: import Cart from "./Cart";

import Cart from "./Cart";


const navItems = [
    { path: "/", icon: <Home size={22} />, label: "Home" },
    { path: "/course", icon: <BookOpen size={22} />, label: "Courses" },
    { path: "/cart", icon: <ShoppingCart size={22} />, label: "Equipments" }, // ✅ correct
    { path: "/admission-form", icon: <BadgeCheck size={22} />, label: "Admission" },
    { path: "/my-account", icon: <User size={22} />, label: "Account" },
];

const MobileBottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="ecommerce-theme2-mobile-bottom-nav">
            {navItems.map(({ path, icon, label }) => {
                const isActive = location.pathname === path;
                return (
                    <div
                        key={path}
                        className={`ecommerce-theme2-mobile-nav-item ${isActive ? "active" : ""
                            }`}
                        onClick={() => navigate(path)}
                    >
                        {icon}
                        {isActive && <span>{label}</span>}
                    </div>
                );
            })}
        </div>
    );
};

export default MobileBottomNav;
